var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VLayout',{attrs:{"title":_vm.$t('recover_pass_confirm.box_title')}},[_c('RecoverPassFormConfirm',{on:{"pass:recovered:success":_vm.onPassRecovered}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }